<script lang="ts" setup>
import type { Category } from '~~/server/api/menu/footer'

export interface FooterMenuProps {
    section: Category
}

const props = defineProps<FooterMenuProps>()

const to = computed<VNuxtLinkTo>(() => {
    if (props.section.meta_product) return { name: props.section.slug }

    return {
        name: 'insurance-category-detail',
        params: { id: props.section.slug },
    }
})
</script>
<template>
  <section>
    <h3 class="text-secondary fs-smaller mb-1">
      <VNuxtLink
        :to="to"
        :label="props.section.title"
      >
        {{ props.section.title }}
      </VNuxtLink>
    </h3>

    <FooterLinks
      class="d-none d-md-block"
      :link-base-url="`poistenie/${props.section.slug}/`"
      :links="props.section.products"
    />
  </section>
</template>
